import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { SessionProvider } from './auth/SessionProvider';
import { App } from './App';

// First, so the @font-face rules exist before anything asks for the families. Self-hosted rather
// than linked from a font CDN in index.html: a remote link discloses every visitor's IP address to a
// third party before the app paints. Generated by landing/scripts/build-fonts.mjs.
import './styles/fonts.css';
// Order matters: tokens define the custom properties that oreia.css consumes, and shell.css
// layers the browser/desktop adaptations on top of both.
import './styles/tokens.css';
import './styles/oreia.css';
import './styles/shell.css';
// Feature-owned, and after the shell so it can correct a design-system rule where the Journal's
// gallery needs one corrected rather than editing oreia.css.
import './styles/gallery.css';
// Feature-owned, and last so its overlay z-indices sit above the shell's.
import './styles/dream-vision.css';
import './styles/self-stats.css';
import './styles/mood-ritual.css';
import './styles/check-ins.css';
import './styles/journals.css';
import './styles/self.css';
import './styles/onboarding.css';
import './styles/journal-companion.css';
import './styles/journal-flow.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
